import http from "./httpService";
import { SafetyTypes } from "../pages/Safety-events";
import { getJwt } from "./authService";
const apiEndpoint = process.env.REACT_APP_API_URL + "/safety-events";

http.setJwt(getJwt()!);

export const postSafety = async (params: SafetyTypes) => {
  const { data } = await http.post(apiEndpoint, { ...params });
  return data;
};
export const putSafety = async (params: any, id: string) => {
  delete params._id;
  delete params.__v;

  const { data } = await http.put(apiEndpoint + `/${id}`, { ...params });
  return data;
};

export default postSafety;
